type ListWorkflowsParams = {
  includeArchived?: boolean
  state?: unknown[]
  workflowType?: unknown
  workflowTypes?: unknown[]
  excludeHiddenFromRequestors?: boolean
}

export const workflowQueryKeys = {
  all: ['workflows'] as const,
  lists: () => [...workflowQueryKeys.all, 'list'] as const,
  list: (params: ListWorkflowsParams) => [...workflowQueryKeys.lists(), params] as const,
  details: () => [...workflowQueryKeys.all, 'detail'] as const,
  detail: (workflowId: string) => [...workflowQueryKeys.details(), workflowId] as const,
  conditionGroups: (workflowId: string) => [...workflowQueryKeys.detail(workflowId), 'condition-groups'] as const,
  draft: (workflowId: string, draftId: string) => [...workflowQueryKeys.detail(workflowId), 'draft', draftId] as const,
  pendingScheduledRequests: (workflowId: string) =>
    [...workflowQueryKeys.detail(workflowId), 'pending-scheduled-requests'] as const,
  events: (workflowId: string) => [...workflowQueryKeys.detail(workflowId), 'events'] as const,
}
